<template>
    <div class="relative">
        <span
            class="sort-toggle d-block d-sm-none"
            @click="sortByDesc = !sortByDesc"
            >{{ sortLabel }}
            <v-icon
                color="#ffff"
                size="18"
                :class="{
                    'fas fa-sort-up': !sortByDesc,
                    'fas fa-sort-down': sortByDesc
                }"
            >
            </v-icon>
        </span>
        <v-data-table
            :headers="headers"
            :items="subscriptions"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortByDesc"
            :items-per-page="50"
            class="table-children ma-lg-8"
        >
            <template v-slot:top>
                <v-toolbar class="mb-12" flat color="white" height="110">
                    <span
                        >Totaal aantal kinderen:
                        <strong>{{ totalSubscriptions }}</strong></span
                    >
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialogComment" max-width="700px">
                        <v-card>
                            <v-card-title>
                                <span class="display-1 mx-auto"
                                    >Opmerking plaatsen</span
                                >
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-textarea
                                                v-model="editedItem.comment"
                                                filled
                                                rounded
                                                color="#202020"
                                                auto-grow
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions
                                class="flex-wrap flex-column flex-md-row"
                            >
                                <v-spacer></v-spacer>
                                <v-btn
                                    class="black--text text-capitalize mb-4 mb-md-0 mr-md-2 mx-auto"
                                    text
                                    @click="closeComment"
                                    >Annuleren</v-btn
                                >
                                <v-btn
                                    color="primary"
                                    min-width="200"
                                    class="d-block btn-primary white--text mb-4 mb-md-0 mr-md-2 mx-auto"
                                    text
                                    @click="saveComment"
                                    >Opslaan</v-btn
                                >
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialog" max-width="700px">
                        <template v-slot:activator="{ on }">
                            <v-btn
                                color="primary"
                                class="d-block btn-primary white--text"
                                v-on="on"
                                >Voeg een kind toe</v-btn
                            >
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="display-1 mx-auto">{{
                                    formTitle
                                }}</span>
                            </v-card-title>

                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field
                                                v-model="editedItem.name"
                                                v-validate="'required'"
                                                name="name"
                                                filled
                                                rounded
                                                dense
                                                min-height="42"
                                                color="#202020"
                                                label="Voornaam"
                                                data-vv-as="Voornaam"
                                                :error-messages="
                                                    errors.collect('name')
                                                "
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field
                                                v-model="editedItem.surname"
                                                filled
                                                rounded
                                                dense
                                                min-height="42"
                                                color="#202020"
                                                label="Achternaam"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-select
                                                v-model="editedItem.sportId"
                                                :items="
                                                    filters.find(
                                                        x => x.name == 'Sport'
                                                    ).children
                                                "
                                                filled
                                                rounded
                                                dense
                                                min-height="42"
                                                color="#202020"
                                                label="Sport"
                                                item-text="name"
                                                item-value="id"
                                            ></v-select>
                                        </v-col>
                                        <v-radio-group
                                            v-model="editedItem.genderId"
                                            row
                                            cols="12"
                                            sm="6"
                                            label="Geslacht"
                                            class="mt-md-6"
                                        >
                                            <v-radio
                                                v-for="n in filters.find(
                                                    x => x.name == 'Geslacht'
                                                ).children"
                                                :key="n.name + '-' + n.id"
                                                :label="n.name"
                                                :value="n.id"
                                            ></v-radio>
                                        </v-radio-group>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-select
                                                v-model="editedItem.statusId"
                                                v-validate="'required'"
                                                :items="
                                                    filters.find(
                                                        x => x.name == 'Status'
                                                    ).children
                                                "
                                                filled
                                                rounded
                                                dense
                                                min-height="42"
                                                color="#202020"
                                                label="Status"
                                                name="status"
                                                item-text="name"
                                                item-value="id"
                                                :error-messages="
                                                    errors.collect('status')
                                                "
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-select
                                                v-model="editedItem.schoolId"
                                                v-validate="'required'"
                                                :items="
                                                    filters.find(
                                                        x => x.name == 'Scholen'
                                                    ).children
                                                "
                                                filled
                                                rounded
                                                dense
                                                min-height="42"
                                                color="#202020"
                                                label="School"
                                                name="school"
                                                item-text="name"
                                                item-value="id"
                                                :error-messages="
                                                    errors.collect('school')
                                                "
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-select
                                                v-model="editedItem.classId"
                                                :items="
                                                    filters.find(
                                                        x => x.name == 'Klas'
                                                    ).children
                                                "
                                                filled
                                                rounded
                                                dense
                                                min-height="42"
                                                color="#202020"
                                                label="Klas"
                                                item-text="name"
                                                item-value="id"
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-select
                                                v-model="
                                                    editedItem.schoolYearId
                                                "
                                                :items="
                                                    filters.find(
                                                        x =>
                                                            x.name ==
                                                            'Schooljaren'
                                                    ).children
                                                "
                                                filled
                                                rounded
                                                dense
                                                min-height="42"
                                                color="#202020"
                                                label="Schooljaar"
                                                item-text="name"
                                                item-value="id"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>

                            <v-card-actions
                                class="flex-wrap flex-column flex-md-row"
                            >
                                <v-spacer></v-spacer>
                                <v-btn
                                    v-show="!isPosting"
                                    class="black--text text-capitalize mb-4 mb-md-0 mr-md-2 mx-auto"
                                    text
                                    @click="close"
                                    >Annuleren</v-btn
                                >
                                <v-btn
                                    :loading="isPosting"
                                    color="primary"
                                    min-width="200"
                                    class="d-block btn-primary white--text mb-4 mb-md-0 mr-md-2 mx-auto"
                                    text
                                    @click="save(true)"
                                    >Nog een kind toevoegen</v-btn
                                >
                                <v-btn
                                    :loading="isPosting"
                                    color="primary"
                                    min-width="200"
                                    class="d-block btn-primary white--text mb-md-0 mr-md-2 mx-auto"
                                    text
                                    @click="save(false)"
                                    >Opslaan</v-btn
                                >
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:item.statusIdName="{ item }">
                {{ getParticularValueById('Status', item.statusId) }}
            </template>
            <template v-slot:item.sportIdName="{ item }">
                {{ getParticularValueById('Sport', item.sportId) }}
            </template>
            <template v-slot:item.schoolYearIdName="{ item }">
                {{ getParticularValueById('Schooljaren', item.schoolYearId) }}
            </template>
            <template v-slot:item.schoolIdName="{ item }">
                {{ getParticularValueById('Scholen', item.schoolId) }}
            </template>
            <template v-slot:item.sexIdName="{ item }">
                {{ getParticularValueById('Geslacht', item.genderId) }}
            </template>
            <template v-slot:item.classIdName="{ item }">
                {{ getParticularValueById('Klas', item.classId) }}
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon @click="editItem(item)">fas fa-edit</v-icon>
                <v-icon
                    :class="
                        typeof item.comment !== 'undefined' &&
                        item.comment !== null &&
                        item.comment.length > 0
                            ? 'fas d-sm-none'
                            : 'far d-sm-none'
                    "
                    @click="placeComment(item)"
                    >fa-comment</v-icon
                >
            </template>
            <template v-slot:item.comment="{ item }">
                <v-icon
                    :class="
                        typeof item.comment !== 'undefined' &&
                        item.comment !== null &&
                        item.comment.length > 0
                            ? 'fas d-none d-sm-block'
                            : 'far d-none d-sm-block'
                    "
                    @click="placeComment(item)"
                    >fa-comment</v-icon
                >
            </template>
        </v-data-table>
    </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import Axios from 'axios';

Vue.use(VeeValidate);
export default {
    $_veeValidate: {
        validator: 'new'
    },
    props: {
        totalSubscriptions: {
            required: true,
            type: Number
        },
        subscriptions: {
            type: Array,
            default() {
                return [];
            }
        },
        filters: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            isPosting: false,
            isLoading: false,
            dialogComment: false,
            dialog: false,
            sortBy: 'createDate',
            sortByDesc: true,
            schoolYearsDropdown: [],
            dictionary: {
                custom: {
                    name: {
                        required: 'Voornaam is een verplicht veld.'
                    },
                    school: {
                        required: 'School is een verplicht veld.'
                    },
                    status: {
                        required: 'Status is een verplicht veld.'
                    }
                }
            },
            headers: [
                { value: 'action', sortable: false },
                { value: 'comment', sortable: false },
                {
                    text: 'Voornaam',
                    sortable: true,
                    value: 'name'
                },
                { text: 'Achternaam', sortable: false, value: 'surname' },
                {
                    text: 'Telefoonnummer',
                    sortable: false,
                    value: 'parentPhoneNumber'
                },
                { text: 'E-mailadres', sortable: false, value: 'parentEmail' },
                { text: 'Sport', sortable: false, value: 'sportIdName' },
                { text: 'Status', sortable: false, value: 'statusIdName' },
                {
                    text: 'J/M',
                    sortable: false,
                    value: 'sexIdName'
                },
                {
                    text: 'School',
                    sortable: false,
                    value: 'schoolIdName'
                },
                {
                    text: 'Klas',
                    sortable: false,
                    value: 'classIdName'
                },
                {
                    text: 'Invoerjaar',
                    sortable: true,
                    value: 'createDate',
                    sort: (a, b) => {
                        const [dayA, monthA, yearA] = (a || '0-0-0').split('-');
                        const [dayB, monthB, yearB] = (b || '0-0-0').split('-');

                        return yearA - yearB || monthA - monthB || dayA - dayB;
                    }
                }
            ],
            editedIndex: -1,
            editedItem: {
                name: '',
                surname: '',
                sport: '',
                statusId: '',
                gender: '',
                school: '',
                class: '',
                schoolYear: '',
                comment: '',
                createDate: '',
                endDate: ''
            },
            defaultItem: {
                name: '',
                surname: '',
                sport: '',
                statusId: '',
                gender: '',
                school: '',
                class: '',
                schoolYear: '',
                comment: '',
                createDate: '',
                endDate: ''
            }
        };
    },

    computed: {
        sortLabel() {
            const activeSort = Array.isArray(this.sortBy)
                ? this.sortBy[0]
                : this.sortBy;
            const header = this.headers.find(x => x.value === activeSort);
            return header ? header.text : '';
        },
        formTitle() {
            return this.editedIndex === -1
                ? 'Voeg een kind toe'
                : 'Pas gegevens aan';
        }
    },

    watch: {
        dialog(val) {
            if (val) {
                this.errors.clear();
            }
            val || this.close();
        }
    },

    mounted() {
        this.$validator.localize('nl', this.dictionary);
        const schoolYears = this.filters.find(x => x.name == 'Schooljaren')
            .children;

        schoolYears.forEach((value, index) => {
            if (value.name == '19/20' || value.name == '20/21') {
                schoolYears.splice(index, 1);
            }
        });
    },
    methods: {
        editItem(item) {
            this.editedIndex = this.subscriptions.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },

        placeComment(item) {
            this.editedIndex = this.subscriptions.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialogComment = true;
        },
        close() {
            this.dialog = false;
            this.resetItemAndIndex();
        },

        closeComment() {
            this.resetItemAndIndex();
            this.dialogComment = false;
        },

        resetItemAndIndex() {
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 0);
        },

        save(showNewCreateDialog) {
            this.$validator
                .validateAll()
                .then(isValidationSuccess => {
                    let url = 'api/data/addsubscription';
                    const currentId = this.editedIndex;
                    const currentItem = this.editedItem;
                    const postData = Object.assign({}, currentItem); //We need another object since changing the birthdate property from currentItem makes the field invalid.
                    if (postData.createDate) {
                        postData.createDate = postData.createDate
                            .split('-')
                            .reverse()
                            .join('-');
                    }
                    if (postData.endDate) {
                        postData.endDate = postData.endDate
                            .split('-')
                            .reverse()
                            .join('-');
                    }
                    if (this.editedIndex > -1) {
                        url = 'api/data/editsubscription';
                    }
                    if (isValidationSuccess && !this.isPosting) {
                        this.isPosting = true;
                        Axios.post(url, postData).then(response => {
                            if (response.data === null) {
                                return false;
                            }
                            if (
                                currentItem.status == '' &&
                                currentItem.statusId == undefined
                            ) {
                                currentItem.statusId = 1;
                            }
                            if (currentId > -1) {
                                Object.assign(
                                    this.subscriptions[currentId],
                                    currentItem
                                );
                            } else {
                                currentItem.createDate =
                                    response.data.createDate;
                                this.subscriptions.push(currentItem);
                            }

                            if (showNewCreateDialog) {
                                this.resetItemAndIndex();
                            } else {
                                this.close();
                            }
                            this.isPosting = false;
                        });
                    }
                })
                .catch(() => false);
        },

        saveComment() {
            const currentId = this.editedIndex;
            const currentItem = this.editedItem;
            const postData = Object.assign({}, currentItem);

            if (postData.createDate) {
                postData.createDate = postData.createDate
                    .split('-')
                    .reverse()
                    .join('-');
            }

            Axios.post('api/data/editsubscription', postData)
                .then(response => {
                    if (response.data === null) {
                        return false;
                    }
                    Object.assign(this.subscriptions[currentId], currentItem);
                    // todo: error
                })
                .catch(() => false);
            this.closeComment();
        },
        getParticularValueById(filterName, value) {
            const selectedFilterOption = this.filters.find(
                x => x.name == filterName
            );
            if (typeof selectedFilterOption == 'undefined') {
                return '';
            }

            const myFilterValue = selectedFilterOption.children.find(
                x => x.id === value
            );
            if (typeof myFilterValue == 'undefined') {
                return '';
            }
            return myFilterValue.name;
        }
    }
};
</script>

<style lang="scss" scoped>
.v-content__wrap {
    background-color: #ffffff;
}

.v-card__actions .v-btn {
    width: 80%;

    @include media-breakpoint-up(md) {
        width: auto;
    }
}

.v-data-table::v-deep .v-data-table-header-mobile {
    display: none;
}

.v-data-table::v-deep td.v-data-table__mobile-row {
    height: 32px;

    &:first-of-type {
        height: 80px;
    }

    &:last-of-type {
        display: none;
    }

    i {
        font-size: 30px;
    }
}

.v-data-table::v-deep .v-data-footer__select {
    display: none;
}

.v-data-table::v-deep i {
    font-size: 18px;
}

.theme--light::v-deep .v-data-table__wrapper {
    border-radius: 9px;
}

.theme--light.v-data-table::v-deep
    .v-data-table-header
    th.sortable.active
    .v-data-table-header__icon,
.theme--light.v-data-table::v-deep .v-data-table-header th.sortable.active,
.theme--light.v-data-table::v-deep .v-data-table-header th.sortable:hover,
.theme--light.v-data-table::v-deep
    .v-data-table-header
    th.sortable
    .v-data-table-header__icon {
    color: #ffffff !important;
    margin-left: 5px;
    margin-top: -5px;
}

.v-text-field--rounded::v-deep > .v-input__control > .v-input__slot {
    border-radius: 9px;
    min-height: 50px;
}

.v-data-table::v-deep th {
    font-size: 16px;
    font-weight: 600;
}

.v-toolbar__title {
    font-size: 1.5rem;
    font-family: 'SingleSleeve';
}

.theme--light.v-data-table::v-deep .v-data-table-header th.sortable:hover {
    color: initial;
}

.theme--light::v-deep.v-data-table
    tbody
    tr:hover:not(.v-data-table__expanded__content) {
    background-color: #ffffff;
}

.theme--light::v-deep.v-data-table
    tbody
    tr:not(:last-child)
    td:not(.v-data-table__mobile-row) {
    border: 0;
}

.theme--light::v-deep.v-data-table thead tr:last-child th {
    border: 0;
    color: #ffffff;
    background-color: #7fd060;
}

.table-children::v-deep tr:nth-child(even) {
    background: #fafafa !important;
}

.sort-toggle {
    background-color: #7fd060;
    color: #ffffff;
    display: block;
    padding: 10px 16px;
    font-size: 0.875rem;
    font-weight: 600;
    position: absolute;
    top: 130px;
    width: 100%;
    left: 0;
    z-index: 3;
}

.sort-toggle .fa-sort-down {
    vertical-align: top;
}
</style>
